import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Rotate', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white",
    fillOpacity: "0.01"
  }), React.createElement("path", {
    d: "M12 24H42V42H12V24Z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M6 8V17H15",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M38.4747 13.2985C35.1956 8.87049 29.933 6 24 6C18.1788 6 13.0029 8.76334 9.71272 13.0498L6 17",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});